import { Box, FormLabel, Switch } from '@ksyos/design-system';
import type { ISwitch } from './OutclinicDashboardTableSwitches';

interface IOutclinicDashboardTableSwitchBoxProps {
    isChecked: boolean;
    label: string;
    onChange: () => void;
    size: 'medium' | 'large';
    switchKey: ISwitch['key'];
}

export function OutclinicDashboardTableSwitchBox(props: IOutclinicDashboardTableSwitchBoxProps) {
    return (
        <Box
            alignItems="center"
            display="flex"
            gap={[2, 4]}
            justifyContent={['space-between', 'flex-end']}
        >
            <FormLabel
                htmlFor={props.switchKey}
                size={props.size}
            >
                {props.label}
            </FormLabel>
            <Switch
                checked={props.isChecked}
                id={props.switchKey}
                onChange={props.onChange}
                size={props.size}
                sx={{ flexShrink: 0 }}
            />
        </Box>
    );
}
